import { render, staticRenderFns } from "./OrganizationDashboardCourses.vue?vue&type=template&id=2d7889f8"
import script from "./OrganizationDashboardCourses.vue?vue&type=script&lang=js"
export * from "./OrganizationDashboardCourses.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDashboardCourses.vue?vue&type=style&index=0&id=2d7889f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports